<template>
  <div class="placements-pill">
    <WdsTooltip
      :global="!fullscreen"
      :text="$tc(':count placement at this client | :count placements at this client', total)"
      class="placements-tooltip"
    >
      <a
        v-if="total > 0"
        :href="allUrl"
        class="placements-segment placements-segment--static"
        :data-test="totalDataTest"
      >
        {{ total.toLocaleString() }}
      </a>
      <span v-else class="placements-segment placements-segment--static" :data-test="totalDataTest">
        {{ total.toLocaleString() }}
      </span>
    </WdsTooltip>
    <WdsTooltip
      :global="!fullscreen"
      :text="$tc(':count active placement | :count active placements', active)"
      class="placements-tooltip"
    >
      <a
        v-if="active > 0"
        :href="activeUrl"
        class="placements-segment placements-segment--active"
        :data-test="activeDataTest"
      >
        {{ active.toLocaleString() }}
      </a>
      <span
        v-else
        class="placements-segment placements-segment--active"
        :data-test="activeDataTest"
      >
        {{ active.toLocaleString() }}
      </span>
    </WdsTooltip>
  </div>
</template>

<script lang="ts" setup>
import { inject } from 'vue'
import { WdsTooltip } from '@worksome/wds-components'
import { $tc } from '@/app-bootstrapping/SetUpInternationalization'
import { TableFullscreen } from '@/components/GraphqlDataTable/injection'

defineProps<{
  total: number
  active: number
  allUrl: string
  activeUrl: string
  totalDataTest?: string
  activeDataTest?: string
}>()

const fullscreen = inject(TableFullscreen, undefined)
</script>

<style lang="scss" scoped>
.placements-pill {
  @apply tw-inline-flex tw-items-stretch tw-overflow-hidden tw-rounded-full tw-bg-white;
  @apply tw-border tw-border-solid tw-border-gray-200;
}

.placements-tooltip {
  @apply tw-flex;
}

.placements-segment {
  @apply tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1 tw-font-medium tw-transition-colors;
  @apply hover:tw-no-underline;
}

.placements-segment--static {
  color: inherit;
}

.placements-segment--active {
  @apply tw-border-0 tw-border-l tw-border-solid tw-border-gray-200;
}

a.placements-segment--active {
  @apply tw-bg-green-200 tw-text-green-600;
}

span.placements-segment--active {
  @apply tw-bg-true-gray-100 tw-text-gray-600;
}

// The global anchor rule recolours text on hover; the pill answers with its background instead.
a.placements-segment--static:hover,
a.placements-segment--static:focus {
  @apply tw-bg-true-gray-300;
  color: inherit;
}

a.placements-segment--active:hover,
a.placements-segment--active:focus {
  @apply tw-bg-green-600 tw-text-white;
}
</style>
